import { DS_IMAGE_TYPE } from '../constants/ds-forms-image-type.constant';
import { DsFormInstanceFieldSignatureInterface } from '../interfaces/form-instance/ds-form-instance-field-signature.interface';

/**
 * Return list of Files from base64.
 *
 * @param file DsFormInstanceFieldSignatureInterface
 * @returns Promise of File[]
 */
export async function getFilesFromBase64(file: DsFormInstanceFieldSignatureInterface): Promise<File> {
  let signature: File;
  await fetch(file?.photo)
    .then((res) => res.blob())
    .then((blob) => {
      signature = new File([blob], file?.fileName, { type: file.type || DS_IMAGE_TYPE.jpeg });
    });

  return signature;
}
